import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/** Preserves query string when redirecting legacy usage-insights user URLs. */
export function LegacyUsageInsightsUserRedirect() {
  const { userId } = useParams<{ userId: string }>();
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  const target = `/operations/usage-insights/users/${userId ?? ''}${query ? `?${query}` : ''}`;
  return (
    <Navigate
      to={target}
      replace
    />
  );
}
